var map = {
	"./404.svg": 26,
	"./barco.svg": 48,
	"./equis.svg": 27,
	"./facebook.svg": 19,
	"./instagram.svg": 34,
	"./linkedin.svg": 20,
	"./pescador.svg": 49,
	"./proceso.svg": 50,
	"./sandwich.svg": 28,
	"./whatsapp.svg": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;